import { IconButton, IIconProps, IModalStyles, Modal } from "@fluentui/react";
import React from "react";
import styled from "styled-components";

interface FullScreenModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  title: string;
  children: React.ReactNode;
}

const modalStyles: Partial<IModalStyles> = {
  main: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    padding: 0,
    overflow: "hidden", // Ensures content is properly constrained
  },
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #f3f2f1;
  border-bottom: 1px solid #ccc;
`;

const Title = styled.h2`
  margin: 0;
`;

const Content = styled.div`
  flex: 1;
  padding: 16px;
  overflow: auto;
  background: white;
  position: relative;
`;

const closeIcon: IIconProps = { iconName: "Cancel" };

const FullScreenModal: React.FC<FullScreenModalProps> = ({
  isOpen,
  onDismiss,
  title,
  children,
}) => {
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} isBlocking={false} styles={modalStyles}>
      <Container>
        <Header>
          <Title>{title}</Title>
          <IconButton iconProps={closeIcon} ariaLabel="Close modal" onClick={onDismiss} />
        </Header>
        <Content>{children}</Content>
      </Container>
    </Modal>
  );
};

export default FullScreenModal;
